export const UPDATE_STATISTIC = "UPDATE_STATISTIC";
export const UPDATE_STATISTIC_MANAGER = "UPDATE_STATISTIC_MANAGER";

export const UPDATE_USERAPP_INFO = "UPDATE_USERAPP_INFO"